function getSectionHeight(pdf, locWp) {
  let h = 0;
  const splitWpDesc = pdf
    .setFontSize(10)
    .setFont("helvetica", "normal")
    .splitTextToSize(locWp.wpFullDescription, 250);
  const splitLocName = pdf
    .setFontSize(10)
    .setFont("helvetica", "normal")
    .splitTextToSize(locWp.locationName, 150);
  const splitWorkDesc = pdf
    .setFontSize(10)
    .setFont("Times", "normal")
    .splitTextToSize(locWp.workDescription, 520);
  const maxSubsectionTitleLines = Math.max(splitWpDesc.length, splitLocName.length);

  // 1. Subsection header (Item/CCO/PI No & Desc., Location Desc)
  if (maxSubsectionTitleLines !== 1) h += (maxSubsectionTitleLines - 1) * 11 + 4;
  else h += 15;
  // 2. Subsection body (Work Desc.)
  h += splitWorkDesc.length * 11;
  // 3. Quantity (if exists)
  if (locWp.quantity > 0) h += 11;
  // 4. Misc materials (if exists)
  if (locWp.miscMaterials.length > 0) {
    h += 11; // Print the first misc mat'l
    locWp.miscMaterials.forEach((lmm, index) => {
      if (index !== 0) h += 11;
    });
  }
  // 5. Tests performed (if exists)
  if (locWp.testsPerformed.length > 0) {
    h += 11; // Subsection header
    locWp.testsPerformed.forEach((ltp, index) => {
      h += 11; // Test type
      h += 11; // No. tests/samples taken
      const splitRemarks = pdf
        .setFont("times", "normal")
        .splitTextToSize(ltp.remarks, 390);
      h += splitRemarks.length * 11;
    });
  }
  // 6. Attachments (filenames only)
  if (locWp.attachments.length > 0) {
    h += 11;
    const splitAttachmentStr = pdf
      .setFont("helvetica", "normal")
      .splitTextToSize(locWp.attachments.join("; "), 500);
    h += splitAttachmentStr.length * 11;
  }
  // 7. Subsection bottom margin
  h += 6;
  pdf.setFont("Helvetica", "normal");
  return h;
}

export default function renderAdrDescOfWorkV3(data) {
  return function (pdf) {
    // let pdf = new jsPDF(); // temporary
    let cursorY = this.cursorY;

    pdf.setFont("helvetica", "bold").setFontSize(12);
    cursorY += 15;
    pdf.text("Location and Description of Operation", 302, cursorY, {
      align: "center",
    });
    cursorY += 4;
    pdf.line(15, cursorY, 590, cursorY);

    if (data.length === 0) {
      // Desc of Work is the first section, so no need to calculate
      // sectionH for printing (N/A)...
      cursorY += 11;
      pdf.setFont("helvetica", "normal").setFontSize(10).text("(None)", 18, cursorY);
      cursorY += 4;
      pdf.line(15, cursorY, 590, cursorY);
    } else {
      // Main loop for printing locWp data
      data.forEach((locWp) => {
        const splitWpDesc = pdf
          .setFontSize(10)
          .setFont("helvetica", "normal")
          .splitTextToSize(locWp.wpFullDescription, 250);
        const splitLocName = pdf
          .setFontSize(10)
          .setFont("helvetica", "normal")
          .splitTextToSize(locWp.locationName, 150);
        const splitWorkDesc = pdf
          .setFontSize(10)
          .setFont("Times", "normal")
          .splitTextToSize(locWp.workDescription, 520);
        const maxSubsectionTitleLines = Math.max(splitWpDesc.length, splitLocName.length);
        let y_lineAboveSubsectionTitle = 0;
        let y_subsectionTitle = 0;

        if (cursorY + getSectionHeight(pdf, locWp) > this.maxY) {
          this._addPage(pdf);
          cursorY = this.cursorY;
          pdf.setFont("helvetica", "bold").setFontSize(12);
          cursorY += 15;
          pdf.text("Location and Description of Operation (Continued)", 288, cursorY, {
            align: "center",
          });
          cursorY += 4;
        }
        pdf.line(15, cursorY, 590, cursorY);
        y_lineAboveSubsectionTitle = cursorY;
        cursorY += 11;
        y_subsectionTitle = cursorY;

        pdf.setFont("Helvetica", "bold").setFontSize(8);
        pdf.text(locWp.wpPrefix, 15, cursorY);
        pdf.setFont("Helvetica", "bold").setFontSize(10);
        pdf.text(locWp.wpNumber ? locWp.wpNumber.toString() : "-", 31, cursorY);
        pdf.setFont("helvetica", "normal");
        splitWpDesc.forEach((l, index) => {
          pdf.text(l, 50, y_subsectionTitle);
          if (index !== splitWpDesc.length - 1) y_subsectionTitle += 11;
        });
        y_subsectionTitle = cursorY; // Bring temp Y cursor back to original position

        pdf
          .setFont("helvetica", "bold")
          .text("Location: ", 300, cursorY)
          .setFont("helvetica", "normal");
        splitLocName.forEach((l, index) => {
          pdf.text(l, 349, y_subsectionTitle);
          if (index !== splitLocName.length - 1) y_subsectionTitle += 11;
        });

        if (maxSubsectionTitleLines !== 1) cursorY += (maxSubsectionTitleLines - 1) * 11;

        pdf
          .setFont("helvetica", "italic")
          .text(locWp.inspectionType, 503, y_lineAboveSubsectionTitle + 11)
          .setFont("helvetica", "normal");
        cursorY += 4;
        pdf.line(500, y_lineAboveSubsectionTitle, 500, cursorY);
        pdf.line(15, cursorY, 590, cursorY);

        pdf.setFont("Times", "normal");

        if (splitWorkDesc.length === 1 && splitWorkDesc[0].length === 0) {
          cursorY += 11;
          pdf.text("(No description of work provided)", 50, cursorY);
        } else {
          splitWorkDesc.forEach((l) => {
            cursorY += 11;
            pdf.text(l, 50, cursorY);
          });
        }

        if (locWp.quantity > 0) {
          cursorY += 11;
          const qtyString = locWp.quantity
            ? locWp.quantity.toString()
            : "0 " + locWp.unitOfMeasure;
          pdf.setFont("helvetica", "bold").text("Quantity:", 50, cursorY);
          pdf.setFont("times", "normal").text(qtyString, 97, cursorY);
        }

        if (locWp.miscMaterials.length > 0) {
          cursorY += 11;
          pdf.setFont("helvetica", "bold").text("Misc. Materials:", 50, cursorY);
          pdf.setFont("times", "normal");
          locWp.miscMaterials.forEach((lmm, index) => {
            const lmmString =
              lmm.materialDescription +
              ", " +
              (lmm.quantity ? lmm.quantity.toString() : "0") +
              " " +
              lmm.unitOfMeasure;
            const splitLmm = pdf.splitTextToSize(lmmString, 450);
            pdf.text(splitLmm[0], 128, cursorY);
            if (index !== locWp.miscMaterials.length - 1) cursorY += 11;
          });
        }

        if (locWp.testsPerformed.length > 0) {
          cursorY += 11;
          pdf.setFont("helvetica", "bold").text("Tests Performed:", 50, cursorY);
          pdf.setFont("helvetica", "normal");
          locWp.testsPerformed.forEach((ltp, index) => {
            const splitRemarks = pdf
              .setFont("times", "normal")
              .splitTextToSize(ltp.remarks, 390);
            pdf.setFont("helvetica", "normal");
            cursorY += 11;
            pdf.text("#" + (index + 1).toString() + ")", 50, cursorY);
            pdf.setFont("helvetica", "italic").text("Test Type:", 70, cursorY);
            pdf.setFont("times", "normal").text(ltp.testType, 121, cursorY);
            cursorY += 11;
            pdf
              .setFont("helvetica", "italic")
              .text("No. of Tests/Samples Taken:", 70, cursorY);
            pdf
              .setFont("times", "normal")
              .text(
                ltp.numberOfTestsOrSamplesTaken
                  ? ltp.numberOfTestsOrSamplesTaken.toString()
                  : "0",
                201,
                cursorY
              );
            cursorY += 11;
            pdf.setFont("helvetica", "italic").text("Remarks:", 70, cursorY);
            pdf.setFont("times", "normal");
            splitRemarks.forEach((l, index) => {
              pdf.text(l, 117, cursorY);
              if (index < splitRemarks.length - 1) cursorY += 11;
            });
          });
        }

        if (locWp.attachments.length > 0) {
          const splitAttachmentStr = pdf
            .setFont("helvetica", "normal")
            .setFontSize(10)
            .splitTextToSize(locWp.attachments.join("; "), 500);
          cursorY += 11;
          pdf.setFont("helvetica", "bold").text("Attachments:", 50, cursorY);
          pdf.setFont("helvetica", "normal");
          splitAttachmentStr.forEach((l, index) => {
            pdf.text(l, 120, cursorY);
            if (index < splitAttachmentStr.length - 1) cursorY += 11;
          });
        }

        cursorY += 6;
      });
    }

    if (cursorY + 11 < this.maxY) cursorY += 11;

    this._setDefaults(pdf);
    this.cursorY = cursorY;
  };
}
